'use client';

import { useEffect, useRef } from 'react';
import { ButtonV2 } from '@/app_components/ui/ButtonV2';
import type { SocialType } from '@/app_lib/types/accounts/signin';
import { setSessionStorageObject } from '@/app_lib/utils/sessionStorageUtils';

interface SocialSignInButtonProps {
  children: React.ReactNode;
  url: string;
  disabled: boolean;
  onLoadingChange: (loading: boolean) => void;
  socialType: SocialType;
}

const POPUP_POLL_INTERVAL_MS = 500;

export const SocialSignInButton = ({
  children,
  url,
  disabled,
  onLoadingChange,
  socialType,
}: SocialSignInButtonProps) => {
  const popupIntervalRef = useRef<number | undefined>(undefined);

  useEffect(() => {
    return () => {
      if (popupIntervalRef.current) {
        clearInterval(popupIntervalRef.current);
      }
    };
  }, []);

  const handleClick = () => {
    onLoadingChange(true);
    const popup = window.open(url, '_blank', 'popup=true,width=600,height=600,top=100,left=500');
    if (!popup) {
      onLoadingChange(false);
      return;
    }
    setSessionStorageObject('__siSocialType', { socialType });

    popupIntervalRef.current = window.setInterval(() => {
      if (popup.closed) {
        window.clearInterval(popupIntervalRef.current);
        popupIntervalRef.current = undefined;
        onLoadingChange(false);
      }
    }, POPUP_POLL_INTERVAL_MS);
  };

  return (
    <ButtonV2
      as='button'
      className='w-full'
      disabled={disabled}
      noCapitalize
      onClick={handleClick}
      size='lg'
      variant='sso'
    >
      {children}
    </ButtonV2>
  );
};
